import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ShowSelectedIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Eye shape */}
      <path
        d="M2 12C4 8 7.5 5 12 5s8 3 10 7c-2 4-5.5 7-10 7s-8-3-10-7z"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinejoin="round"
      />
      {/* Pupil with selection indicator (checkmark inside) */}
      <circle cx="12" cy="12" r="3" stroke={color} strokeWidth={strokeWidth} fill="none" />
      {/* Selection checkmark */}
      <path
        d="M10 12l1.5 1.5L14 11"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </BaseIcon>
  ),
);

ShowSelectedIcon.displayName = 'ShowSelectedIcon';
